import React from 'react';

type Props = {
  name: React.ReactNode;
  value: React.ReactNode;
};

function NamedProperty({ name, value }: Props) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-500">{name}</div>
      <div className="mt-1 text-sm text-gray-900">{value}</div>
    </div>
  );
}

export default NamedProperty;
